import Base from '@studiometa/js-toolkit/abstracts/Base';
import withIntersectionObserver from '@studiometa/js-toolkit/decorators/withIntersectionObserver';
import gsap from 'gsap';

/**
 * Scroll component
 * @usage data-component="Scroll" to add a scroll reveal animation
 * @options anim: fade|title
 */
export default class Scroll extends withIntersectionObserver(Base) {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'Scroll',
    };
  }

  /**
   * Triggered when the root element of the component is intersecting.
   * @param  {Array<IntersectionObserverEntry>} entries
   */
  intersected(entries) {
    if (
      entries[0].isIntersecting && // Run the animation if component is not visible
      !this.isVisible
    ) {
      const fn = `${this.$options.anim}Animation`;
      // Call animation function
      if (typeof this[fn] === 'function') {
        this[fn]();
      }
    }
  }

  /**
   * Fade animation
   */
  fadeAnimation() {
    gsap.to(this.$el, {
      opacity: 1,
      duration: 1.4,
      delay: this.$options.delay ? this.$options.delay : 0.2, // ?? syntax does not work on safari
      ease: 'sine.out',
      onComplete: () => {
        // Update component visibility
        this.isVisible = true;
      },
    });
  }

  /**
   * Title animation
   */
  titleAnimation() {
    gsap.to(this.$el, { opacity: 1, duration: 0 });
    gsap.fromTo(
      this.$refs.letters,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.8,
        delay: 0.2,
        ease: 'sine.out',
        stagger: {
          each: 0.02,
        },
        onComplete: () => {
          // Update component visibility
          this.isVisible = true;
        },
      }
    );
  }
}
